import React from "react";
import { memo } from "react";

interface EventosCardProps {
  dadosEventos: any[];
}

function EventosCard({ dadosEventos }: EventosCardProps) {
  return (
    <div className="eventos-card">
      <h2>Eventos</h2>
      {dadosEventos.map((dado, index) => (
        <p key={index}>
          <strong>-</strong> {dado.evento.nome}
        </p>
      ))}
    </div>
  );
}

export default memo(EventosCard);
